module.exports = __webpack_public_path__ + "img/emptyReports.f29d254f.png";